import { IconProps } from "@radix-ui/react-icons/dist/types";
import * as React from "react";

export const Cross3Icon = React.memo(function Cross3Icon({
  color = "currentColor",
  ...props
}: IconProps) {
  return (
    <svg
      width="15"
      height="15"
      viewBox="0 0 15 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M4.7048 3.99769C4.50954 3.80243 4.19295 3.80243 3.99769 3.99769C3.80243 4.19295 3.80243 4.50954 3.99769 4.7048L6.79289 7.5L3.99769 10.2952C3.80243 10.4905 3.80243 10.8071 3.99769 11.0023C4.19295 11.1976 4.50954 11.1976 4.7048 11.0023L7.5 8.20711L10.2952 11.0023C10.4904 11.1975 10.8071 11.1976 11.0023 11.0023C11.1976 10.807 11.1975 10.4904 11.0023 10.2952L8.20711 7.5L11.0023 4.7048C11.1975 4.50956 11.1976 4.19295 11.0023 3.99769C10.8071 3.80243 10.4904 3.80246 10.2952 3.99769L7.5 6.79289L4.7048 3.99769Z"
        fill={color}
      />
    </svg>
  );
});
